module.exports = __webpack_public_path__ + "img/commerce_active.772d6103.svg";